import "./notfound-style.scss"

export const NotFound = () => {
    return <h1>Page not found</h1>
}